import { useEffect, useMemo, useState } from "react";
import { Container } from "../../shared/Components/Container/Container";
import { ElementBreadCrumb } from "../../shared/Components/ElementBreadCrumb";
import { ElementItemCardGenerico } from "../../shared/Components/Programados/ElementItemCardGenerico";
import { InputSearch } from "../../shared/Components/ReactBootstrap/InputSearch/InputSearch";
import { LanguageTranslate } from "../../shared/Infraestructure/LanguageTranslate";
import { useSelector } from "react-redux";
import { RootState } from "../../shared/Infraestructure/AdapterStore";
import { ViewError } from "../../shared/Components/ViewError";
import { SomacylOrderENTITY } from "sigo-entities";
import ButtonFloating from "../../shared/Components/ButtonFloating/ButtonFloating";
import { ViewLoading } from "../../shared/Components/ViewLoading";
import { OffCanvasBottom } from "../../shared/Components/ReactBootstrap/OffCanvasBottom/OffCanvasBottom";
import { AddInventory } from "./AddInventory";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import { InfoOrder } from "./InfoOrder";
import { FinalizeOrder } from "./FinalizeOrder";
import { useNavigate } from "react-router-dom";
import {
    useItemsEspañaRepository,
    useSomacylOrdersRepository
} from "../../shared/Infraestructure/hooks";

export function ViewOrdenesSomacyl() {
    const languageTranslate = LanguageTranslate()
    const navigate = useNavigate()
    const [searchTerm, setSearchTerm] = useState<string>('')
    const [show, setShow] = useState<boolean>(false)
    const [showInfoOrder, setShowInfoOrder] = useState<boolean>(false)
    const [ownPersonal, setOwnPersonal] = useState<boolean>(false)
    const [showFinalizeOrder, setShowFinalizeOrder] = useState<boolean>(false)
    const [showBadge, setShowBadge] = useState<boolean>(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const { user } = useSelector((state: RootState) => state.auth)
    const { data, isLoading, isError, error, getByIdSomacylOrders } = useSomacylOrdersRepository()
    const rutaOperaciones = '/main/operaciones'

    const pipelineItems = [{
        $match: {
            'Pais.Codigo': user.Pais.Codigo,
            'Delegacion.Codigo': user.Delegacion.Codigo,
            'Estado.ID_Estado': 1
        }
    }]
    const {
        currentData: dataItems,
        isLoading: isLoadingItems,
        isError: isErrorItems,
        error: errorItems
    } = useItemsEspañaRepository({
        pipeline: pipelineItems
    })

    const filteredData = data.filter((e) => {
        if (showBadge && e.inventory.length === 0) {
            return false
        }

        const term = searchTerm.trim().toUpperCase()
        if (!term) return true
        return (
            e.numero_de_peticion?.toUpperCase().includes(term) ||
            e.subtipo_de_actividad?.toUpperCase().includes(term) ||
            e.ubicacion.localidad?.toUpperCase().includes(term) ||
            e.ubicacion.direccion_completa_y_referencia?.toUpperCase().includes(term)
        )
    })

    const selectedOrder = useMemo(
        () => data?.find((item) => item._id === selectedId),
        [data, selectedId]
    )

    useEffect(() => {
        getByIdSomacylOrders()
    }, [])

    useEffect(() => {
        if (user.ColeccionEmpresa.length !== 1) {
            AdapterGenerico
                .createMessage('Alerta', `Usted pertenece a ${user.ColeccionEmpresa.length} empresas`, 'error')
                .then(() => navigate(rutaOperaciones))
        }
        setOwnPersonal(user.ColeccionEmpresa[0].Propia)
    }, [user])

    const onAddInventoryClick = (e: SomacylOrderENTITY) => {
        try {
            setSelectedId(e._id)
            setShow(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onFinalizeClick = async (e: SomacylOrderENTITY) => {
        try {
            setSelectedId(e._id)
            setShowFinalizeOrder(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    const onInfoClick = (e: SomacylOrderENTITY) => {
        try {
            setSelectedId(e._id)
            setShowInfoOrder(true)
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    if (isLoading || isLoadingItems) return <ViewLoading />

    return (
        <Container>
            <ElementBreadCrumb list={[
                { text: languageTranslate.menu['070'].titulo, navigate: true, path: rutaOperaciones },
                { text: languageTranslate.menu['076'].titulo, navigate: false, path: '' }]}
            />
            <InputSearch
                handleChange={(text) => setSearchTerm(text.toUpperCase())}
            />
            {
                (isError || isErrorItems)
                    ? <ViewError error={error || errorItems} />
                    : <>
                        {
                            filteredData.map((e, i) => (
                                <ElementItemCardGenerico
                                    key={i}
                                    icono
                                    onClick={() => onAddInventoryClick(e)}
                                    icono1='fa-solid fa-box-archive'
                                    icono2='fa-solid fa-check-to-slot'
                                    icono3='fa-solid fa-circle-info'
                                    colorIcono1={e.pendingSync ? 'warning' : e.inventory.length ? 'success' : 'danger'}
                                    colorIcono2='info'
                                    onClick2={onFinalizeClick}
                                    onClick3={onInfoClick}
                                    text1={<span style={{ fontSize: 12 }}>N° petición</span>}
                                    data1={<span style={{ color: '#e0e0e0', fontSize: 12 }}>{e.numero_de_peticion}</span>}
                                    text2={<span style={{ fontSize: 12 }}>Dirección</span>}
                                    data2={<span style={{ color: '#e0e0e0', fontSize: 12 }}>{e.ubicacion.direccion_completa_y_referencia}</span>}
                                    text3={<span style={{ fontSize: 12 }}>Actividad</span>}
                                    data3={<span style={{ color: '#e0e0e0', fontSize: 12 }}>{e.subtipo_de_actividad}</span>}
                                    text4={<span style={{ fontSize: 12, color: 'white' }}>Estado</span>}
                                    data4={<span style={{ color: 'yellow', fontSize: 12 }}>{e.estado_actividad}</span>}
                                    item={e}
                                />
                            ))
                        }
                    </>
            }
            <ButtonFloating
                onClick={() => setShowBadge(!showBadge)}
                icono='fa-solid fa-filter'
                colorIcono='#43a64b'
                backgroundColor="#69b4ffff"
                right={70}
                showBadge={showBadge}
            />
            <ButtonFloating
                onClick={async () => await getByIdSomacylOrders()}
                icono='fa-solid fa-arrows-rotate'
                colorIcono='#2C3E50'
            />
            <OffCanvasBottom
                height={100}
                show={show}
                setShow={setShow}
                children={
                    selectedOrder && show
                        ? <AddInventory
                            row={selectedOrder}
                            dataItems={dataItems ?? []}
                            ownPersonal={ownPersonal}
                        />
                        : null
                }
            />
            <OffCanvasBottom
                height={100}
                show={showInfoOrder}
                setShow={setShowInfoOrder}
                children={
                    selectedOrder && showInfoOrder
                        ? <InfoOrder
                            row={selectedOrder}
                        />
                        : null
                }
            />
            <OffCanvasBottom
                height={100}
                show={showFinalizeOrder}
                setShow={setShowFinalizeOrder}
                children={
                    selectedOrder && showFinalizeOrder
                        ? <FinalizeOrder
                            row={selectedOrder}
                            user={user}
                            setShowFinalizeOrder={setShowFinalizeOrder}
                            getByIdSomacylOrders={getByIdSomacylOrders}
                        />
                        : null
                }
            />
        </Container>
    )
}